import { useEffect, useState, useCallback } from "react";

type UseConsentReturn = {
  isAccepted: boolean;
  setAccepted: (val: boolean) => void;
  showError: boolean;
  setShowError: (v: boolean) => void;
  handleCheckboxChange: (checked: boolean) => void;
};

export function useConsent(consentKey: string): UseConsentReturn {
  const storageKey = `consent:${consentKey}`;
  const [isAccepted, setIsAccepted] = useState(false);
  const [showError, setShowError] = useState(false);

  // ALL’APERTURA: forza reset (niente persistenza)
  useEffect(() => {
    try {
      sessionStorage.removeItem(storageKey);
      localStorage.removeItem(storageKey);
    } catch {/* ignore */}
    setIsAccepted(false); // esplicito
  }, [storageKey]);

  const setAccepted = useCallback((val: boolean) => {
    setIsAccepted(val);
    // Nessun salvataggio su storage
  }, []);

  const handleCheckboxChange = useCallback((checked: boolean) => {
    setAccepted(checked);
    if (checked) setShowError(false);
  }, [setAccepted]);

  return { isAccepted, setAccepted, showError, setShowError, handleCheckboxChange };
}
